<template>
    <main-content>
        <div class="row mt-4">
            <div class="col-sm my-3" v-if=" transaction.transaction_type !=='استرداد وجه'">
                <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
                    <div class="d-flex">
                        <div class="px-4 ml-auto">تاریخچه تراکنش</div>
                    </div>
                    <hr>
                    <div class="p-4">
                        <div class="timeline timeline-1">
                            <div class="timeline-sep bg-primary-opacity-20"></div>
                            <div id="before_transaction" class="timeline-item"
                                 v-if="transaction.transaction_type !='شارژ کیف پول پیامکی' && (transaction.description.initial_balance ||
                     transaction.description.transaction_amount || transaction.wage)">
                                <div class="timeline-badge">
                                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12
                        2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0
                        1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/>
                                    </svg>
                                </div>
                                <div class="timeline-content text-dark font-weight-normal">
                                <div class="mb-2 h5">
                                        وضعیت قبل از تراکنش
                                    </div>
                                    <div class="mt-1">
                                        <span class="text-muted">موجودی قبل از تراکنش: </span>
                                        <span class=" text-muted">
                                          <span
                                              v-if="showBalance"
                                          >
                                            {{ initial_balance }}
                                          ریال
                                          </span>
                                          <button
                                              id="balance-inquiry"
                                              @click="balanceInquiry"
                                              v-else
                                              class="btn btn-primary"
                                              type="button"
                                          >
                                            محاسبه
                                          </button>
                                        </span>
                                    </div>
                                    <div class="mt-1" v-if="transaction.description.transaction_amount">
                                        <span class="text-muted">مبلغ تراکنش: </span>
                                        <span class=" text-muted">
                      {{ transaction.description.transaction_amount }}
                      ریال
                    </span>
                                    </div>
                                    <div class="mt-1" v-if="transaction.wage">
                                        <span class="text-muted">کارمزد تراکنش: </span>
                                        <span class=" text-muted">
                      {{ transaction.wage }}
                      ریال
                    </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timeline-item"
                                 v-if="transaction.description.transaction_update_date || transaction.description.tracking_code">
                                <div class="timeline-badge">
                                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12
                        2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0
                        1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/>
                                    </svg>
                                </div>
                                <div class="timeline-content text-dark font-weight-normal">
                                    <div class="mb-2 h5">
                                        تغییر وضعیت تراکنش
                                    </div>
                                    <span class="text-muted">{{ transaction.description.transaction_update_date }}</span>
                                    <div class="mt-1">
                                        <span class="text-muted">وضعیت تراکنش: </span>
                                        <span class=" text-danger"
                                              v-if="transaction.description.transaction_status == 'transaction.failed'">ناموفق</span>
                                        <span class=" text-success"
                                              v-if="transaction.description.transaction_status == 'transaction.succeeded'">موفق</span>
                                    </div>
                                    <div class="mt-1" v-if="transaction.description.result_message">
                                        <span class="text-muted">پاسخ دریافتی: </span>
                                        <span class=" text-muted">{{ transaction.description.result_message }}</span>
                                    </div>
                                    <div class="mt-1" v-if="transaction.description.bank_verification">
                                        <span class="text-muted">تایید بانک: </span>
                                        <span class=" text-muted">{{ transaction.description.bank_verification }}</span>
                                    </div>

                                </div>
                            </div>

                            <div class="timeline-item" v-if="transaction.description.api_verify_date">
                                <div class="timeline-badge">
                                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12
                        2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0
                        1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/>
                                    </svg>
                                </div>
                                <div class="timeline-content text-dark font-weight-normal">
                                    <div class="mb-2 h5">
                                        وریفای تراکنش توسط کاربر
                                    </div>
                                    <span class="mt-1 text-muted"> {{ transaction.description.api_verify_date }}</span>
                                </div>
                            </div>

                            <div id="after_transaction" class="timeline-item"
                                 v-if="this.transaction.transaction_type !='شارژ کیف پول پیامکی' && (transaction.description.final_balance ||
                     transaction.description.added_amount)">
                                <div class="timeline-badge">
                                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12
                        2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0
                        1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/>
                                    </svg>
                                </div>
                                <div class="timeline-content text-dark font-weight-normal">
                                    <div class="mb-2 h5">
                                        وضعیت بعد از تراکنش
                                    </div>
                                    <div class="mt-1" v-if="showBalance">
                                        <span class="text-muted">موجودی بعد از تراکنش: </span>
                                        <span class=" text-muted">
                                      {{ final_balance }}
                                      ریال
                                    </span>
                                    </div>
                                    <div class="mt-1" v-if="transaction.description.added_amount">
                                        <span class="text-muted">مبلغ اضافه شده به موجودی: </span>
                                        <span class=" text-muted" v-if="transaction.transaction_type == transactionStr.CARD_TO_CARD">
                                            0
                                        ریال
                                        </span>
                                        <span class=" text-muted" v-else>
                                        {{ transaction.description.added_amount }}
                                        ریال
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div :class="detailClass">
                <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
                    <div class="d-flex">
                        <div class="px-4 ml-auto">جزییات تراکنش</div>
                    </div>
                    <hr>

                    <div class="transaction-detail">
                        <div class="px-4 mt-4 d-flex align-items-center">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                                d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شناسه تراکنش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 en_num">{{ transaction.id }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.ref_id && transaction.ref_id != transaction.id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                                d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">کد رهگیری</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 en_num">{{ transaction.description.tracking_code }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.ref_id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                                d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شماره مرجع بانکی</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 en_num">{{ transaction.ref_id }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.factor_number">
                          <div class="ml-auto d-flex align-items-center">

                            <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                 width="24" xmlns="http://www.w3.org/2000/svg">
                              <g>
                                <rect fill="none" height="24" width="24"/>
                              </g>
                              <g>
                                <path d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                              </g>
                            </svg>
                            <div>
                              <div class="pr-4 mt-2">شناسه واریز/شماره فاکتور</div>
                            </div>
                          </div>
                          <div>
                            <div class="pl-4 en_num">{{ transaction.factor_number }}</div>
                          </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.api_order_id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                        <path
                                                d="M18,6h-2c0-2.21-1.79-4-4-4S8,3.79,8,6H6C4.9,6,4,6.9,4,8v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8C20,6.9,19.1,6,18,6z
                          M12,4c1.1,0,2,0.9,2,2h-4C10,4.9,10.9,4,12,4z M18,20H6V8h2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8h4v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8
                           h2V20z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شماره سفارش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.api_order_id }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.order_id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                        <path
                                                d="M18,6h-2c0-2.21-1.79-4-4-4S8,3.79,8,6H6C4.9,6,4,6.9,4,8v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8C20,6.9,19.1,6,18,6z
                          M12,4c1.1,0,2,0.9,2,2h-4C10,4.9,10.9,4,12,4z M18,20H6V8h2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8h4v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8
                           h2V20z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شناسه سفارش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.order_id }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.refund_parent_transaction_id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                            d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شناسه تراکنش مسترد شده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">
                                    <router-link
                                        :to="'/transactions/' + transaction.refund_parent_transaction_id + '/details'"
                                        class="text-success"
                                        @click.native="$router.go()"
                                    >
                                        {{transaction.refund_parent_transaction_id}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.refund_transferable_id">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                            d="M20,10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4H20z M14,14h-4v-4h4V14z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شناسه انتقال وجه</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">
                                    <router-link
                                        class="text-success"
                                        :to="getTransferUrlByMethod(transaction)"
                                    >
                                        {{transaction.refund_transferable_id}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                        <path fill="#00bea5" d="M18,6h-2c0-2.21-1.79-4-4-4S8,3.79,8,6H6C4.9,6,4,6.9,4,8v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8 C20,6.9,19.1,6,18,6z M12,4c1.1,0,2,0.9,2,2h-4C10,4.9,10.9,4,12,4z M18,20H6V8h2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8h4v2c0,0.55,0.45,1,1,1 s1-0.45,1-1V8h2V20z"/>
                                        <path fill="#00bea5" d="M8 12h8v2H8z"/>
                                        <path fill="#00bea5" d="M10 16h4v2h-4z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">نوع تراکنش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.transaction_type }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.card_number">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                            d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شماره کارت/شبا پرداخت کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4" dir="ltr">
                                    <div>
                                        {{ transaction.card_number }}
                                    </div>
                                    <div v-if="transaction.refund_iban != null">
                                        {{ transaction.refund_iban }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.destination_card_number">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                            d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">شماره کارت مقصد</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4" dir="ltr">{{ transaction.destination_card_number }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.api_payer_phone || transaction.description.phone">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">موبایل پرداخت کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.api_payer_phone }}</div>
                                <div class="pl-4">{{ transaction.description.phone }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.api_payer_name">
                            <div class="ml-auto d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">نام پرداخت کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.api_payer_name }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.api_payer_mail">
                            <div class="ml-auto d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">ایمیل پرداخت کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 en_num">{{ transaction.description.api_payer_mail }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.api_description">
                            <div class="ml-auto d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">توضیحات تراکنش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 en_num">{{ transaction.description.api_description }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.transaction_amount != undefined &&
                                transaction.description.transaction_amount != null">
                            <div class="ml-auto d-flex align-items-center">
                                <i class="fa fa-money-bill-wave text-success fa-lg"></i>
                                <div>
                                    <div class="pr-4 mt-2">{{ $t("label.transaction_amount") }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.transaction_amount }} {{ $t("label.rial")
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.transaction_real_amount && transaction.transaction_type !='استرداد وجه'">
                            <div class="ml-auto d-flex align-items-center">
                                <i class="fa fa-money-bill-wave text-success fa-lg"></i>
                                <div>
                                    <div class="pr-4 mt-2">{{ $t("label.transaction_real_amount") }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.transaction_real_amount }} {{ $t("label.rial")
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.wage != undefined && transaction.wage != null">
                            <div class="ml-auto d-flex align-items-center">
                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76v0.36c0,0.48-0.39,0.88-0.88,0.88h0 c-0.48,0-0.88-0.39-0.88-0.88v-0.42c-0.63-0.15-1.93-0.61-2.69-2.1c-0.23-0.44-0.01-0.99,0.45-1.18l0.07-0.03 c0.41-0.17,0.87,0,1.08,0.39c0.32,0.61,0.95,1.37,2.12,1.37c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5.88C11.12,5.39,11.52,5,12,5h0c0.48,0,0.88,0.39,0.88,0.88v0.37 c1.07,0.19,1.75,0.76,2.16,1.3c0.34,0.44,0.16,1.08-0.36,1.3l0,0C14.32,9,13.9,8.88,13.66,8.57c-0.28-0.38-0.78-0.77-1.6-0.77 c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45C15.9,17.17,13.4,17.67,12.88,17.76z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">کارمزد تراکنش</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.wage }} ریال</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.transaction_wage_bank">
                            <div class="ml-auto d-flex align-items-center">
                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76v0.36c0,0.48-0.39,0.88-0.88,0.88h0 c-0.48,0-0.88-0.39-0.88-0.88v-0.42c-0.63-0.15-1.93-0.61-2.69-2.1c-0.23-0.44-0.01-0.99,0.45-1.18l0.07-0.03 c0.41-0.17,0.87,0,1.08,0.39c0.32,0.61,0.95,1.37,2.12,1.37c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5.88C11.12,5.39,11.52,5,12,5h0c0.48,0,0.88,0.39,0.88,0.88v0.37 c1.07,0.19,1.75,0.76,2.16,1.3c0.34,0.44,0.16,1.08-0.36,1.3l0,0C14.32,9,13.9,8.88,13.66,8.57c-0.28-0.38-0.78-0.77-1.6-0.77 c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45C15.9,17.17,13.4,17.67,12.88,17.76z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">کارمزد بانکی</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.transaction_wage_bank }} ریال</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.callback_url">
                            <div class="ml-auto d-flex align-items-center">
                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path d="M17,7h-3c-0.55,0-1,0.45-1,1s0.45,1,1,1h3c1.65,0,3,1.35,3,3s-1.35,3-3,3h-3c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h3 c2.76,0,5-2.24,5-5S19.76,7,17,7z M8,12c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1s-0.45-1-1-1H9C8.45,11,8,11.45,8,12z M10,15H7 c-1.65,0-3-1.35-3-3s1.35-3,3-3h3c0.55,0,1-0.45,1-1s-0.45-1-1-1H7c-2.76,0-5,2.24-5,5s2.24,5,5,5h3c0.55,0,1-0.45,1-1 C11,15.45,10.55,15,10,15z"/>
                                        </g>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">آدرس بازگشت</div>
                                </div>
                            </div>
                            <div>
                                <div class="d-none d-md-block pl-4 en_num text-left" dir="ltr">{{
                                    transaction.description.callback_url }}
                                </div>
                                <div class="d-block d-md-none pl-4 en_num text-left" dir="ltr"
                                     style="max-width: 175px; overflow-wrap: break-word;">{{
                                    transaction.description.callback_url }}
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.merchant_callback_response_code">
                            <div class="ml-auto d-flex align-items-center">
                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <g>
                                            <path d="M17,7h-3c-0.55,0-1,0.45-1,1s0.45,1,1,1h3c1.65,0,3,1.35,3,3s-1.35,3-3,3h-3c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h3 c2.76,0,5-2.24,5-5S19.76,7,17,7z M8,12c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1s-0.45-1-1-1H9C8.45,11,8,11.45,8,12z M10,15H7 c-1.65,0-3-1.35-3-3s1.35-3,3-3h3c0.55,0,1-0.45,1-1s-0.45-1-1-1H7c-2.76,0-5,2.24-5,5s2.24,5,5,5h3c0.55,0,1-0.45,1-1 C11,15.45,10.55,15,10,15z"/>
                                        </g>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">پاسخ برگشتی سایت پذیرنده</div>
                                </div>
                            </div>
                            <div>
                                <div class="d-none d-md-block pl-4 en_num text-left" dir="ltr">{{
                                    transaction.description.merchant_callback_response_code }}
                                </div>
                                <div class="d-block d-md-none pl-4 en_num text-left" dir="ltr"
                                     style="max-width: 175px; overflow-wrap: break-word;">{{
                                    transaction.description.merchant_callback_response_code }}
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.terminal_title">
                            <div class="ml-auto d-flex align-items-center">

                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                            d="M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">نام درگاه</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.terminal_title }}</div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center" v-if="transaction.port">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M0,0h24v24H0V0z" fill="none"/>
                                    </g>
                                    <g>
                                        <path
                                                d="M20,4H4C2.89,4,2.01,4.89,2.01,6L2,18c0,1.11,0.89,2,2,2h5v-2H4v-6h18V6C22,4.89,21.11,4,20,4z M20,8H4V6h16V8z M14.93,19.17l-2.83-2.83l-1.41,1.41L14.93,22L22,14.93l-1.41-1.41L14.93,19.17z"/>
                                    </g>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">پی اس پی / بانک</div>
                                </div>
                            </div>
                            <div class="pl-4">
                                <div v-if="transaction.port_code == 'MELLAT'">
                                    <img src="/assets/media/psp/mellat.png" width="32" height="32" class="">
                                </div>
                                <div v-else-if="transaction.port_code == 'PARSIAN'">
                                    <img src="/assets/media/psp/parsian.svg" width="32" height="32">
                                </div>
                                <div v-else-if="transaction.port_code == 'PASARGAD'">
                                    <img src="/assets/media/psp/pasargad.svg" width="32" height="32">
                                </div>
                                <div v-else-if="transaction.port_code == 'SAMAN'">
                                    <img src="/assets/media/psp/saman.svg" width="32" height="32">
                                </div>
                                <div v-else-if="transaction.port_code == 'NOVIN'">
                                    <img src="/assets/media/psp/novin.svg" width="32" height="32">
                                </div>
                                <div v-else-if="transaction.port_code == 'SEPEHR'">
                                    <img src="/assets/media/psp/sepehr.png" width="32" height="32">
                                </div>
                                <div v-else-if="transaction.port_code == 'IRANKISH'">
                                    <img src="/assets/media/psp/irankish.png" width="32" height="32">
                                </div>
                                <div v-else v-text="transaction.port"></div>
                            </div>
                        </div>
                        <div class="px-4 mt-4 d-flex align-items-center" v-if="transaction.description.payment_description">
                            <div class="ml-auto d-flex align-items-center">

                                <svg enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24"
                                     width="24" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M0,0h24v24H0V0z" fill="none"/>
                                    </g>
                                    <g>
                                        <path
                                            d="M20,4H4C2.89,4,2.01,4.89,2.01,6L2,18c0,1.11,0.89,2,2,2h5v-2H4v-6h18V6C22,4.89,21.11,4,20,4z M20,8H4V6h16V8z M14.93,19.17l-2.83-2.83l-1.41,1.41L14.93,22L22,14.93l-1.41-1.41L14.93,19.17z"/>
                                    </g>
                                </svg>
                                <div class="row">
                                    <div class="col-4">
                                        <div class="pr-4 mt-2">شرح پرداخت</div>
                                    </div>
                                    <div class="col-8" v-text="transaction.description.payment_description">
                                    </div>
                                </div>

                            </div>
                        </div>

                      <div class="px-4 mt-4 d-flex align-items-center" v-if="transaction.description.payer_name">
                        <div class="ml-auto d-flex align-items-center">

                          <span class="fa fa-user" style="color: #00bea5; font-size: 20px"></span>

                          <div>
                            <div class="pr-4 mt-2">نام پرداخت کننده</div>
                          </div>
                        </div>
                        <div class="pl-4">
                          {{transaction.description.payer_name }}
                        </div>
                      </div>
                      <div class="px-4 mt-4 d-flex align-items-center" v-if="transaction.description.payer_phone">
                        <div class="ml-auto d-flex align-items-center">

                          <span class="fa fa-mobile-alt" style="color: #00bea5;  font-size: 23px"></span>
                          <div>
                            <div class="pr-4 mt-2">موبایل پرداخت کننده</div>
                          </div>
                        </div>
                        <div class="pl-4">
                          {{transaction.description.payer_phone}}
                        </div>
                      </div>
                      <div class="px-4 mt-4 d-flex align-items-center" v-if="transaction.description.payer_description">
                        <div class="ml-auto d-flex align-items-center">

                          <span class="fa fa-info-circle" style="color: #00bea5;  font-size: 23px"></span>
                          <div>
                            <div class="pr-4 mt-2">توضیحات پرداخت کننده</div>
                          </div>
                        </div>
                        <div class="pl-4">
                          {{transaction.description.payer_description}}
                        </div>
                      </div>

                      <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.pardakht_shakhsi_payer_name">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">نام پرداخت‌کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.pardakht_shakhsi_payer_name }}</div>
                            </div>
                        </div>

                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.pardakht_shakhsi_payer_phone">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">تلفن پرداخت‌کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.pardakht_shakhsi_payer_phone }}</div>
                            </div>
                        </div>

                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.pardakht_shakhsi_username">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">نام کاربری</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.pardakht_shakhsi_username }}</div>
                            </div>
                        </div>

                        <div class="px-4 mt-4 d-flex align-items-center"
                             v-if="transaction.description.pardakht_shakhsi_payer_description">
                            <div class="ml-auto d-flex align-items-center">
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">توضیحات پرداخت‌کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4">{{ transaction.description.pardakht_shakhsi_payer_description }}</div>
                            </div>
                        </div>

                        <div class="px-4 my-4 d-flex align-items-center"
                             v-if="transaction.description.payer_ip">
                            <div class="ml-auto d-flex align-items-center">

                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93
                      6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43
                      1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82
                      2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35
                      6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
                                </svg>
                                <div>
                                    <div class="pr-4 mt-2">آی پی پرداخت کننده</div>
                                </div>
                            </div>
                            <div>
                                <div class="pl-4 d-flex align-items-center">
                                    <div>{{ transaction.description.payer_ip }}</div>
                                    <country-flag :country="transaction.country" class="mr-2"
                                                  size="normal"></country-flag>
                                </div>
                            </div>
                        </div>
                        <div v-if="transaction.should_refund_transaction && transaction.port_code === 'PASARGAD'">
                            <div>
                                <div class="pl-5 pr-4"  v-if="transaction.status === 'SUCCEED'">
                                    <button type="button" id="refund_btn" @click="openRefundModel" class="btn  btn-danger btn-block"> برگشت تراکنش</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="transaction.refund_data.length > 0">
                            <div style="margin-top: 20px!important;margin-bottom: 10px!important;" class="pr-4 mt-2">جزئیات استرداد وجه های انجام
                                شده
                            </div>
                            <div class="px-3">
                                <div class="table-responsive">
                                    <table
                                        class="table table-responsive table-borderless text-center"
                                    >
                                        <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                style="background-color: #eee; border-radius: 0 16px 16px 0;font-size: x-small"
                                            >
                                                مبلغ
                                            </th>
                                            <th
                                                scope="col" style="background-color: #eee;font-size: x-small"
                                            >
                                                وضعیت
                                            </th>
                                            <th
                                                scope="col" style="background-color: #eee;font-size: x-small"
                                            >
                                                شناسه تراکنش استرداد وجه
                                            </th>
                                            <th
                                                scope="col"
                                                style="background-color: #eee; border-radius: 16px 0 0 16px;font-size: x-small"
                                            >
                                                شناسه انتقال
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                            v-for="(transaction_refund, index) in transaction.refund_data"
                                            :key="index"
                                        >
                                            <td>
                                               {{transaction_refund.amount}}
                                            </td>
                                            <td>
                                                 <span :class="statusClass(transaction_refund.status)">
                                                    {{ transaction_refund.status }}
                                                </span>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="'/transactions/' + transaction_refund.refund_transaction_id + '/details'"
                                                    class="text-success"
                                                    @click.native="$router.go()"
                                                >
                                                    {{transaction_refund.refund_transaction_id}}
                                                </router-link>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="getTransferUrl(transaction_refund)"
                                                    class="text-success"
                                                >
                                                    {{transaction_refund.transferable_id}}
                                                </router-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <refundModal :get_data="get_data" :refund_methods="refund_methods" ref="approveComponent" :transaction_hashid="transaction.id" :wallet_list="wallet_list"></refundModal>
        </div>

    </main-content>
</template>

<script>
    import MainContent from "@/components/main-content";
    import { transactionService, walletService } from '@/common/api.service';
    import { KTApp } from '@/plugins/core/app'
    import toastr from "toastr";
    import $ from 'jquery'
    import refundModal from '@/components/elements/modal/refund-modal.vue';
    import {transactionStr, transactionTypes} from "@/constants/transactionTypes";

    export default {
        name: "details",
        components: {MainContent, refundModal},
        data() {
            return {
                transaction: null,
                initial_balance: null,
                final_balance: null,
                transactionStr,
                transactionTypes,
                refund_methods: {},
                modal:{}
            }
        },
        computed: {
            query() {
                return 'query[id]=' + this.$route.params.hashid + '&query[show_details]=true';
            },
            toastr() {
              toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
              }
              return toastr
            },
            showBalance() {
              return this.initial_balance != null && this.initial_balance != '-';
            },
            detailClass() {
                if (this.transaction.transaction_type === 'استرداد وجه') {
                    return 'col-sm my-6';
                }
                return 'col-sm my-3';
            }
        },
        methods: {
            openRefundModel() {
                let btn = $('#refund_btn');
                KTApp.progress(btn)

                transactionService.fetchRefundMethods({})
                    .then(({data}) => {
                        this.refund_methods = data.data;
                        this.$refs.approveComponent.openModal();
                    }).finally(() => {
                        KTApp.unprogress(btn)
                });

            },
            statusClass(status) {
                switch (status) {
                    case 'در حال انجام':
                        return 'status-pending'
                    case 'موفق':
                        return 'status-success'
                    case 'ناموفق':
                        return 'status-failed'
                    default:
                        return ''
                }
            },
            getTransferUrl(transaction_refund) {
                if (transaction_refund.method === 1) {
                    return '/wallets/settlement-list/' + transaction_refund.wallet_id + '?transfer_id=' + transaction_refund.transferable_id
                }
                if (transaction_refund.method === 2) {
                    return '/open-banking/bank-transfers/' + transaction_refund.application_id + '?transfer_id=' + transaction_refund.transferable_id
                }
            },
            getTransferUrlByMethod(transaction) {
                if (transaction.refund_method === 1) {
                    return '/wallets/settlement-list/' + transaction.refund_wallet_id + '?transfer_id=' + transaction.refund_transferable_id
                }
                if (transaction.refund_method === 2) {
                    return '/open-banking/bank-transfers/' + transaction.refund_application_id + '?transfer_id=' + transaction.refund_transferable_id
                }
            },
            get_data() {
                transactionService.fetchTransaction(this.query).then(json => {
                    this.transaction = json.data.data.data[0];
                    this.initial_balance = json.data.data.data[0].description.initial_balance;
                    this.final_balance = json.data.data.data[0].description.final_balance;
                })
            },
            balanceInquiry() {
              let transaction_hashid = this.$route.params.hashid
              let btn = $('#balance-inquiry')

              KTApp.progress(btn)
                transactionService.balanceInquiry(transaction_hashid)
                  .then(async (response) => {
                    this.initial_balance = response.data.data.initial_balance
                    this.final_balance = response.data.data.final_balance
                    await this.get_data()
                    this.toastr.success(response.data.message)
                  })
                  .catch(({response}) => {
                    this.toastr.error(response.data.message)
                  })
                  .finally(() => {
                    KTApp.unprogress(btn)
                  })
            }
        },
        mounted() {
            this.get_data();
        }
    }
</script>

<style scoped>
    .timeline-item {
        display: flex;
        margin-bottom: 3.5rem;
        align-items: center;

    }


    .timeline-sep {
        z-index: 0;
        content: '';
        position: absolute;
        right: 13px;
        width: 4px;
        top: 0;
        bottom: 0;
        background-color: #EBEDF3;
    }


    .timeline.timeline-1 {
        position: relative;
    }


    .timeline-label {
        flex: 0 0 60px;
        font-weight: 500;
        color: #B5B5C3;
    }

    .timeline-badge {
        display: flex;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 50%;
        border: 4px solid white;
        position: relative;
        z-index: 0;
    }

    .timeline-badge svg {
        fill: #00bea5;
    }


    .timeline-content {
        flex-grow: 1;
        font-size: 1rem;
        padding: 0 0.75rem 0 0;
    }


    .transaction-detail svg {
        fill: #00bea5;
    }

    .status-pending {
        background-color: #f59e0b;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .status-success {
        background-color: #10b981;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .status-failed {
        background-color: #ef4444;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
    }
</style>
